<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $tc("F&B Category Analytics") }}</div>
      <div class="section-title mb-4"></div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- START DATE -->
          <div class="col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema && selectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :options="cinemaList"
                v-model="selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  type="date"
                  v-model="fromDate"
                  @selected="onChangeDate($event, 'from')"
                  :disabled-dates="disabledDates"
                  typeable
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">{{
                  $t("fromdate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  type="date"
                  typeable
                  :disabledDates="{
                    from: new Date(
                      moment(fromDate)
                        .add(31, 'd')
                        .format('YYYY-MM-DD')
                    )
                  }"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xl-3 align-self-center mb-4">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fetchFnbAnalyticsChart"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
            v-if="fnbRecords.length"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="fetchFnbAnalyticsChart('Y')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4" v-if="false">
            <div
              class="btn-group pull-right"
              role="group"
              aria-label="Basic example"
            >
              <button
                type="button"
                @click="OnSelectFNBFilter('Day')"
                class="btn btn-secondary"
              >
                {{ $tc("day") }}
              </button>
              <button
                type="button"
                @click="OnSelectFNBFilter('Week')"
                class="btn btn-secondary"
              >
                {{ $tc("week") }}
              </button>
              <button
                type="button"
                @click="OnSelectFNBFilter('Month')"
                class="btn btn-secondary"
              >
                {{ $tc("month") }}
              </button>
            </div>
          </div>

          <!-- Sales Collection -->
          <table class="swc-report-table mb-3" border="1">
            <thead class="bg-lightgrey font-weight-bold">
              <th>Cinema Name</th>
              <th>Fnb Category</th>
              <th>Quantity</th>
              <th>Total Amount</th>
              <th>CATEGORY MX PERCENTAGE REPORT</th>
            </thead>
            <tbody v-if="fnbRecords.length">
              <tr v-for="(item, index) in fnbRecords">
                <td
                  class="text-left"
                  v-if="index == 0"
                  :rowspan="fnbRecords.length"
                >
                  {{ item.cine_name }}
                </td>
                <td class="text-left">{{ item.fc_category }}</td>
                <td class="text-right">{{ item.quantity }}</td>
                <td class="text-right">{{ currFormat(item.totalAmount) }}</td>
                <td class="text-right">
                  {{ currFormat(item.percentage_sale) }}%
                </td>
              </tr>
              <tr
                class="bg-lightgrey font-weight-bold"
                v-if="fnbRecords.length"
              >
                <td colspan="2" class="text-left">Grand Total</td>

                <td class="text-right">
                  {{ currFormat(grandTotal.quantity) }}
                </td>
                <td class="text-right">
                  {{ currFormat(grandTotal.totalAmount) }}
                </td>
                <td class="text-right">
                  100.00%
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/ChartComponents/LineChart.js";
import PieChart from "@/components/ChartComponents/PieChart.js";
import NoRecords from "@/components/Partials/NoRecords.vue";
import NewReportsService from "@/services/NewReportService";

import MasterService from "@/services/MasterService";
import moment from "moment";

export default {
  components: { LineChart, PieChart, NoRecords },
  data() {
    return {
      selectedCinema: "",
      cinemaList: [],
      fromDate: new Date(),
      toDate: new Date(),
      disabledDates: {
        from: new Date()
      },
      fnbRecords: [],
      grandTotal: {}
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.getFnbLables,
        datasets: this.getFnbdatasets
      };
    },
    PiechartDataFnBItems() {
      return {
        labels: this.getFnBpielabels,
        datasets: this.getFnBpiedatasets
      };
    },
    CategoryChartData() {
      return {
        labels: this.getFnbLables,
        datasets: this.getFnBCategoriesdatasets
      };
    },
    PiechartDataFnBCategories() {
      return {
        labels: this.getFnBCategoriesPieLabel,
        datasets: this.getFnBCategoriesPieDatasets
      };
    }
  },
  beforeMount() {
    // console.log("screenCollectionReportsList :", screenCollectionReportsList);
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;

    this.getCinemaList();
  },
  mounted() {},
  methods: {
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    fetchFnbAnalyticsChart(isExcel) {
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      }
      if (!this.selectedCinema) {
        return this.$toasted.show("Select Cinema");
      }
      let payload = {
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        cinema_id:
          this.selectedCinema && this.selectedCinema.cine_id
            ? this.selectedCinema.cine_id
            : "",
        cinema_name:
          this.selectedCinema && this.selectedCinema.cine_name
            ? this.selectedCinema.cine_name
            : "",
        cinema_address:
          this.selectedCinema && this.selectedCinema.cine_address
            ? this.selectedCinema.cine_address
            : "",
        isExcel: isExcel == "Y" ? "Y" : "N"
      };
      let loader = this.$loading.show();
      NewReportsService.GetFoodCategoryAnalytics(payload)
        .then(response => {
          loader.hide();
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.fnbRecords = [...data.Records];
            this.grandTotal = {
              ...data.grandTotal
            };
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            // this.$toasted.show(data.message);
            // this.dropDown.cinemas = [...data.Records];
            // this.CinemasCopy = [...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
      console.log(payload);
    },
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let cinemas = [
              {
                cine_id: "all",
                cine_name: "All Cinemas"
              }
            ];
            if (data.Records.length == 1) {
              cinemas = [];
            }
            this.cinemaList = [...data.Records];
            // this.dropDown.cinemas = [...data.Records];
            // this.CinemasCopy = [...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  },
  beforeDestroy: async function() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbAnalyticsCategory.vue